const KEY = "tenant_hint";

const APP_ROUTES = new Set(["zertifikat","abrechnung","accept-invite","anwesenheit","avgs","beschwerde","brand-preview","branding","coaches","dashboard","designer-access","dozenten","einrichtung","email-protokoll","entries","feedback","forgot-password","fragebogen","vertretungsplan","terminplanung","termine-bestaetigen","meine-termine","interne-audit","kalender","kapazitaet","kpi","kunden-status","lizenzen","login","management","mein-arbeitstag","mein-bereich","meine-zertifikate","mitarbeiter","plattform","postfach","reset-password","team-pm","termin-unterschreiben","termine","traeger","traegerbestaetigung","umfrage","umfrage-ergebnisse","unterlagen-pruefung","verbleibsquote","vertraege","vertrag-unterschreiben","weiterbildung","wochenkontrolle","wochenuebersicht", "t", "api", "static", "assets", "payment"]);

// Erkennt /<träger>/… (und alt: /t/<träger>/…), merkt sich den Träger und entfernt das Präfix aus der URL.
export function initTenantFromUrl() {
  const path = window.location.pathname;
  const m = path.match(/^\/t\/([a-z0-9][a-z0-9-]{1,30})(\/.*)?$/) || path.match(/^\/([a-z0-9][a-z0-9-]{1,30})(\/.*)?$/);
  if (!m || APP_ROUTES.has(m[1])) return null;
  localStorage.setItem(KEY, m[1]);
  window.history.replaceState(null, "", (m[2] || "/login") + window.location.search + window.location.hash);
  return m[1];
}

export const tenantHint = () => localStorage.getItem(KEY) || "";

export function setTenantHint(slug) {
  if (slug) localStorage.setItem(KEY, slug);
  else localStorage.removeItem(KEY);
}

export const withTenant = (url) => {
  const t = tenantHint();
  return t ? `${url}${url.includes("?") ? "&" : "?"}t=${t}` : url;
};

export function applyBrand(color) {
  const root = document.documentElement.style;
  if (color && /^#[0-9a-fA-F]{6}$/.test(color)) {
    root.setProperty("--brand", color);
    root.setProperty("--brand-active", color);
  } else {
    root.removeProperty("--brand");
    root.removeProperty("--brand-active");
  }
}
